<div class="row forms_area">
    <div class="progress">
        <div class="cicle_dotted" [ngClass]="{'form_valid': isFormValid()}"><span *ngIf="isFormValid()" class="material-symbols-outlined icon">
                check
            </span></div>
        <div class="line" *ngIf="decorativeLineVisible"></div>
    </div>
    <div class="card">
        <div class="card_header">
            <div class="row row_jc_space_btw row_ai_center">
                <p class="title fz_l fw_700">Платежный адрес</p>
                <div class="btn_container">
                    <button class="btn btn_cancel" *ngIf="isAnyFieldFilled()" (click)="removeAll()">Очистить</button>
                </div>
            </div>
        </div>
        <div class="card_body">
            <div class="filter_list grid">
                <label class="inp_group">
                    <div class="lbl">Страна</div>
                    <select name="country" class="inp" (ngModelChange)="addAddressCountry($event)" [(ngModel)]="order.address.country">
                        <option [ngValue]="undefined">Выберите страну</option>
                        <option *ngFor="let country of countries" [value]="country.name">{{country.name}}</option>
                    </select>
                </label>
                <label class="inp_group">
                    <div class="lbl">Штат</div>
                    <select name="country" class="inp" [(ngModel)]="order.address.state">
                        <option [ngValue]="undefined">Выберите штат</option>
                        <option *ngFor="let state of states" [value]="state.name">{{state.name}}</option>
                    </select>
                </label>
                <label class="inp_group">
                    <div class="lbl">Город</div>
                    <input type="text" name="city" [(ngModel)]="order.address.city" class="inp" placeholder="Brooklyn">
                </label>
                <label class="inp_group">
                    <div class="lbl">Zip Code</div>
                    <input type="text" name="zipCode" [(ngModel)]="order.address.postalCode" class="inp" placeholder="10005">
                </label>
                <label class="inp_group">
                    <div class="lbl">Адрес</div>
                    <input type="text" name="address" class="inp" [(ngModel)]="order.address.street" placeholder="99 Wall Street #5553">
                </label>
                <label class="inp_group">
                    <div class="lbl">Имя <span class="color_violet fz_xs">(не обязательно)</span></div>
                    <input type="text" name="firstname" class="inp" [(ngModel)]="order.address.firstname" placeholder="John">
                </label>
                <label class="inp_group">
                    <div class="lbl">Фамилия <span class="color_violet fz_xs">(не обязательно)</span></div>
                    <input type="text" name="lastname" class="inp" [(ngModel)]="order.address.lastname" placeholder="Doe">
                </label>
                <label class="inp_group">
                    <div class="lbl">Телефон <span class="color_violet fz_xs">(не обязательно)</span></div>
                    <app-input-tel name="phone" [phoneValue]="order.address.phone" [phoneCode]="order.address.phone?.[0]" (phoneValueChange)="order.address.phone = $event"></app-input-tel>
                </label>
                <label class="inp_group">
                    <div class="lbl">Email <span class="color_violet fz_xs">(не обязательно)</span></div>
                    <input type="email" name="email" class="inp" [(ngModel)]="order.address.email" placeholder="xonisnik@gmail.com">
                </label>
            </div>
            <button
                class="btn dark_btn row fz_s fw_500 cursor_pointer" [disabled]="!isFormValid()" (click)="openNextStep()">Дальше</button>
        </div>
    </div>
</div>